export default __webpack_public_path__ + "static/c1-7b04c2f7567e66bb4dec4c55d0726d46.png";